"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToOptimize() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ready-to-optimize" className="dark bg-background text-foreground py-24 md:py-[120px] relative overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-secondary/5 rounded-full blur-[100px] pointer-events-none" aria-hidden="true" />

      <div ref={ref} className={`container mx-auto px-4 flex flex-col items-center text-center max-w-4xl relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground leading-tight">
          Your Enterprise-Grade Future Awaits.
        </h2>
        
        <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-2xl font-light">Schedule your 30-minute call to see if we are a good fit</p>

        <div className="relative group">
          {}
          <div className="absolute -inset-2 bg-secondary rounded-full blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-500" aria-hidden="true" />
          
          <Button asChild size="lg" variant="secondary" className="relative text-lg px-8 py-7 h-auto rounded-full font-semibold shadow-2xl shadow-secondary/20 transition-transform hover:scale-105">
            <Link to="/ContactPage">
              Schedule Consultation
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}